<template>
<li class="record">
  <div class="record-col">
    <div class="record-item record--timestamp">
      {{ date }}
    </div>
  </div>
  <div class="record-col">
    <img :src="images[lqi]" width="32" height="32">
  </div>
  <div class="record-col">
    <div class="record-row">
      <div class="record-item record--sigfox-meta">
        seq = {{ sequence }}
      </div>
      <div class="record-item record--sensor-meta">
        temp = {{ minTemp }} 〜 {{ maxTemp }}℃, vol = {{ voltage }}V
      </div>
      <div class="record-item record--rinfo" @click="isRinfoClosed = !isRinfoClosed">
        <div class="record-item record--rinfo-summary" v-if="isRinfoClosed">
          {{ rinfo.length }} stations
        </div>
        <ul class="record-item record--rinfo-items" v-else>
          <li v-for="r in rinfo" :key="r.baseStationId">
            {{ r.baseStationId }} rssi = {{ r.rssi }} snr = {{ r.snr }}
          </li>
        </ul>
      </div>
    </div>
    <div class="record-row">
      <div class="record-item record--message" :class="{ 'record--message-error': isError(messages[4]) }">
        mes4 = {{ messages[4] }}
      </div>
      <div class="record-item record--message" :class="{ 'record--message-error': isError(messages[3]) }">
        mes3 = {{ messages[3] }}
      </div>
      <div class="record-item record--message" :class="{ 'record--message-error': isError(messages[2]) }">
        mes2 = {{ messages[2] }}
      </div>
      <div class="record-item record--message" :class="{ 'record--message-error': isError(messages[1]) }">
        mes1 = {{ messages[1] }}
      </div>
    </div>
  </div>
</li>
</template>

<script>
export default {
  name: 'SensorRecord01',
  props: ['message'],
  data () {
    return {
      timestamp: 0,
      lqi: 0,
      minTemp: 15,
      maxTemp: 30,
      voltage: 2.9,
      messages: [0, 1, 2, 3, 4],
      sequence: 0,
      rinfo: [],
      isRinfoClosed: true,
      images: [
        require('@/assets/radio0.png'),
        require('@/assets/radio1.png'),
        require('@/assets/radio2.png'),
        require('@/assets/radio3.png'),
        require('@/assets/radio4.png'),
      ],
    }
  },
  computed: {
    date () {
      if (this.timestamp === 0) {
        return '';
      }
      const d = new Date(this.timestamp);
      return d.toLocaleString();
    }
  },
  watch: {
    message: {
      handler (value) {
        this.lqi = 0;
        this.maxTemp = 0;
        this.minTemp = 0;
        this.voltage = 0;
        this.messages = [0, 0, 0, 0, 0];
        this.sequence = 0;

        if (value == null) {
          return;
        }
        let data = ''
        for (let i = 0; i < value.data.length; i++) {
          data += parseInt(value.data[i], 16).toString(2).padStart(4, '0');
        }

        this.sequence = parseInt(data.substring(8, 16), 2);
        this.minTemp = parseInt(data.substring(20, 28), 2) * sign(data[18]);
        this.maxTemp = parseInt(data.substring(30, 38), 2) * sign(data[28]);
        this.voltage = parseInt(data.substring(40, 48), 2) / 10;
        this.messages[4] = parseInt(data.substring(48, 60), 2);
        this.messages[3] = parseInt(data.substring(60, 72), 2);
        this.messages[2] = parseInt(data.substring(72, 84), 2);
        this.messages[1] = parseInt(data.substring(84, 96), 2);
        this.lqi = value.lqi;
        this.timestamp = value.timestamp;
        this.rinfo.splice(0, this.rinfo.length);
        this.rinfo.push(... value.rinfo);
      },
      immediate: true,
    }
  },
  methods: {
    isError (value) {
      return value === 1444 || value === 1555;
    },
    getHeader () {
      return [
        'timestamp', 'sequence', 'minTemp', 'maxTemp', 'voltage',
        'lqi', 'message1', 'message2', 'message3', 'message4',
      ];
    },
    getValue () {
      return {
        timestamp: new Date(this.timestamp).toISOString(),
        sequence: this.sequence,
        minTemp: this.minTemp,
        maxTemp: this.maxTemp,
        voltage: this.voltage,
        lqi: this.lqi,
        message1: this.messages[1],
        message2: this.messages[2],
        message3: this.messages[3],
        message4: this.messages[4],
      };
    },
  }
}

const sign = (value) => value === '1' ? -1 : +1;
</script>

<style scoped>
.record {
  border-bottom: 1px solid #aaa;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  display: flex;
  flex-direction: row;
}
.record:first-child {
  border-top: 1px solid #aaa;
}

.record-row {
  text-align: left;
}
.record-col {
  display: flex;
  flex-direction: column;
}
.record-item {
  /* display: flex; */
  display: inline-block;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.record--message-error {
  color: #721c24;
  background-color: #f8d7da;
}

.record--timestamp {
  width: 10rem;
  text-align: left;
}

.record--rinfo {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SensorRecord01.vue